import React from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
  progress: number;
}

export const PullToRefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
  pullDistance,
  isRefreshing,
  progress
}) => {
  if (pullDistance === 0 && !isRefreshing) return null;

  return (
    <div
      className="fixed top-0 left-1/2 -translate-x-1/2 z-50 pointer-events-none"
      style={{
        transform: `translate(-50%, ${Math.min(pullDistance - 40, 20)}px)`,
        opacity: Math.min(progress, 1),
        paddingTop: 'env(safe-area-inset-top)'
      }}
    >
      <div className="bg-primary text-primary-foreground rounded-full p-3 shadow-elegant">
        {isRefreshing ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <RefreshCw 
            className="w-5 h-5 transition-transform duration-200"
            style={{
              transform: `rotate(${progress * 360}deg)`
            }}
          />
        )}
      </div>
    </div>
  );
};
